import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import ArtigoNovoPage from '@/pages/sites/artigo-novo-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

const artigoNovoSearchSchema = z.object({
  gerarIsa: z
    .string()
    .optional()
    .transform((value) =>
      value?.replace(/^"+|"+$/g, '').trim() || undefined,
    ),
  titulo: z.string().optional(),
  categoria: z.string().optional(),
  descricao: z.string().optional(),
})

// Rota para criar novo artigo do blog
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/novo',
)({
  validateSearch: artigoNovoSearchSchema,
  component: function ArtigoNovoRoute() {
    const { dashboardId, siteId } = Route.useParams()
    const search = Route.useSearch()

    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_SITES_BLOG}>
        <ArtigoNovoPage
          dashboardId={dashboardId}
          siteId={siteId}
          isaSearch={search}
        />
      </ProtectedRoute>
    )
  },
})
